"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Observer =
/** @class */
function () {
  function Observer() {
    /**
     * list of observers to dispatch by event.
     */
    this.observers = [];
  }

  Observer.prototype.emit = function (event, data) {
    this.observers.filter(function (observer) {
      return observer.name === event;
    }).forEach(function (observer) {
      return observer.fn(data);
    });
    return this;
  };

  Observer.prototype.register = function (event, fn) {
    this.observers.push({
      name: event,
      fn: fn
    });
    return this;
  };

  return Observer;
}();

exports.default = Observer; //# sourceMappingURL={"version":3,"file":"module.js","sourceRoot":"","sources":["module.tsx"],"names":[],"mappings":";;AAMA;IAAA;QACE;;WAEG;QACK,cAAS,GAAiB,EAAE,CAAC;IAcvC,CAAC;IAZC,uBAAI,GAAJ,UAAK,KAAa,EAAE,IAAU;QAC5B,IAAI,CAAC,SAAS;aACX,MAAM,CAAC,UAAA,QAAQ,IAAI,OAAA,QAAQ,CAAC,IAAI,KAAK,KAAK,EAAvB,CAAuB,CAAC;aAC3C,OAAO,CAAC,UAAA,QAAQ,IAAI,OAAA,QAAQ,CAAC,EAAE,CAAC,IAAI,CAAC,EAAjB,CAAiB,CAAC,CAAC;QAE1C,OAAO,IAAI,CAAC;IACd,CAAC;IAED,2BAAQ,GAAR,UAAS,KAAa,EAAE,EAAuB;QAC7C,IAAI,CAAC,SAAS,CAAC,IAAI,CAAC,EAAE,IAAI,EAAE,KAAK,EAAE,EAAE,IAAA,EAAE,CAAC,CAAC;QACzC,OAAO,IAAI,CAAC;IACd,CAAC;IACH,eAAC;AAAD,CAAC,AAlBD,IAkBC"}